module.exports = __webpack_public_path__ + "static/tagheurer-4c04a7faf9eea475dd261a56ccdaa969.png";